import React from 'react';
import ContactsFiltersModal from './ContactsFiltersModal';
import { Button } from '../../../components/ui/button';
import { InputField } from '../../../components/ui/input-field';
import { Search, Download, Filter } from 'lucide-react';

const estadoOptions = ['IA Activa', 'IA Inactiva'];

const ContactsHeader: React.FC = () => {
    const [showFiltersModal, setShowFiltersModal] = React.useState(false);
    const [etapa, setEtapa] = React.useState('');
    const [agente, setAgente] = React.useState('');
    const [usuario, setUsuario] = React.useState('');
    const [estado, setEstado] = React.useState('');

    return (
        <div className="space-y-6">
            <div className="flex items-center justify-between place-items-center max-md:flex-col">
                {/* First row: title and input */}
                <div className="flex items-center w-full max-md:w-full max-md:mb-2">
                    <h1 className="text-2xl font-bold text-maxi-text-dark max-md:mr-2">Contactos</h1>
                    <div className="relative flex-1 max-w-md max-md:w-full md:ml-auto">
                        <InputField
                            label=""
                            name="search"
                            value={""}
                            onChange={() => { }}
                            placeholder="Buscar"
                            className="pl-10 mt-4 bg-background border-maxi-border"
                            icon={<Search className="w-6 h-6 text-[#BDBDBD] flex-shrink-0" />}
                        />
                    </div>
                </div>
                {/* Second row: buttons */}
                <div className="flex items-center gap-3 w-full max-md:mt-2 justify-center md:justify-end">
                    <Button variant="default" className="gap-2 rounded-full">
                        <Download className="w-4 h-4" />
                        Exportar
                    </Button>
                    <Button variant="default" className="gap-2 rounded-full" onClick={() => setShowFiltersModal(true)}>
                        <Filter className="w-4 h-4" />
                        Filtros
                    </Button>
                </div>
            </div>
            <ContactsFiltersModal
                open={showFiltersModal}
                onClose={() => setShowFiltersModal(false)}
                etapa={etapa}
                setEtapa={setEtapa}
                agente={agente}
                setAgente={setAgente}
                usuario={usuario}
                setUsuario={setUsuario}
                estado={estado}
                setEstado={setEstado}
                etapaOptions={[]}
                agenteOptions={[]}
                usuarioOptions={[]}
                estadoOptions={estadoOptions}
                onClear={() => {
                    setEtapa('');
                    setAgente('');
                    setUsuario('');
                    setEstado('');
                    setShowFiltersModal(false);
                }}
                onApply={() => setShowFiltersModal(false)}
            />
        </div>
    );
};

export default ContactsHeader;
